import React from "react";
import { useState } from "react";
import {
  Button,
  TextField,
  Grid,
} from "@mui/material";
import * as sweetalert from "sweetalert";
import axios from "axios";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const FormHelp = ({ id }) => {

  const [formValues, setFormValues] = useState({
    reply: {
      value: "",
      error: false,
      errorMessage: "You must enter a first name",
    },
  });

  const onSubmit = (event) => {
    event.preventDefault();
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: null,
        sameSite: "strict",
      },
    };
    const data = {
      reply:formValues.reply,
    };

        axios
          .post(`${BaseUrl}/api/replyToHelp/${id}`, data, {
            withCredentials: true,
          })
          .then((res) => {
          
            if (res.status === 200) {
              // sweetalert("تمت علية الرد على الطلب بنجاح", {
              //   className: "alert-div",
              //   button: {
              //     text: "تم",
              //   },
              // }).then(() => {
         
              //   })
                sweetalert({
                  text: "تمت علية الرد على الطلب بنجاح",
                  icon: "success",
                  buttons: {
                    confirm: {
                      text: "تم",
                      className: "custom-button-class",
                    },
                  },
                  className: "alert-div",
                  })
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
              // sweetalert("تمت علية الرد على الطلب بنجاح", {
              //   className: "alert-div",
              //   button: {
              //     text: "تم",
              //   },
              // }).then(() => {
            
              //   window.location.reload(); // Corrected the case here
              // });
            }
            //  else {
            //   sweetalert("error");
            // }
          });
  };

  const handleChange = (e) => {
    e.persist();
    
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };


  return (
    <form onSubmit={onSubmit}>
      <div className="form-group">
        <Grid container maxWidth="sm" spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="رد على الطلب"
              type="text"
              className="form-control"
              id="reply"
              name="reply"
              fullWidth
              onChange={handleChange}
              value={formValues.reply.value}
            />
          </Grid>
        </Grid>
      </div>

      <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
        <Button
          type="submit"
          variant="contained"
          className="btn-submit"
          color="secondary"
        >
          حفظ
        </Button>
      </Grid>
    </form>
  );
};
export default FormHelp;
